<template>
  <div
    class="captcha-container"
  >
    <vue-hcaptcha
      ref="captcha"
      :sitekey="$env.VUE_APP_HCAPTCHA_SITE_KEY"
      @verify="response => setCaptchaToken(response)"
      @expired="() => reset()"
      @error="() => reset()"
    />
  </div>
</template>
<script>
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
export default {
  components: {
    VueHcaptcha,
  },
  data() {
    return {
      resizeObserver: null,
    };
  },
  mounted() {
    const captchaElement = this.$refs.captcha;
    this.resizeObserver = new ResizeObserver(this.onResize);
    this.resizeObserver.observe(captchaElement.$el);
  },
  methods: {
    setCaptchaToken (token) {
      this.postCaptchaMessage('success', { token: token });
    },
    onResize(entries) {
      const entry = entries[0];
      if (entry == null) return;
      this.postSizeChange(entry.contentRect.width, entry.contentRect.height);
    },
    reset () {
      this.postCaptchaMessage('reset');
    },
    postCaptchaMessage(type, data) {
      const channel = window.Captcha;
      if (!channel) return;
      channel.postMessage(JSON.stringify({
        type,
        data,
      }));
    },
    postSizeChange(width, height) {
      const channel = window.SizeChange;
      if (!channel) return;
      channel.postMessage(JSON.stringify({
        width, height,
      }));
    },
  },
};
</script>
<style>
body {
  overflow:hidden;
}
.c-theme-provider{
  background-color: unset !important;
}
.captcha-container{
  display:flex;
  justify-content: center;
  align-items:center;
  min-height: 100%;
}
</style>
